import { StoreOrder } from '../../models';
import { ClockIcon, AlertTriangleIcon } from '../ui/Icons';
import { formatReservationDeadline, parseInstant } from '../../utils/reservation';
import { ORDER_STATUS } from './orderStatus';

export const AWAITING_PAYMENT_ORDER_STATUS = ORDER_STATUS.AwaitingPayment;

interface OrderReservationNoticeProps {
  order: StoreOrder;
}

export function OrderReservationNotice({ order }: OrderReservationNoticeProps) {
  if (order.status !== AWAITING_PAYMENT_ORDER_STATUS) return null;

  const expiresAt = parseInstant(order.reservationExpiresAt);
  const isActive =
    order.reservationStatus === 'Active' && expiresAt !== null && expiresAt.getTime() > Date.now();
  const isExpired =
    order.reservationStatus === 'Expired' ||
    (order.reservationStatus === 'Active' && expiresAt !== null && !isActive);

  if (isActive && expiresAt) {
    return (
      <div className="flex items-center gap-2 px-4 sm:px-5 py-2.5 text-sm text-chocolate-dark bg-champagne/60 border-t border-champagne">
        <ClockIcon className="w-4 h-4 shrink-0" />
        <span>Peças reservadas até {formatReservationDeadline(expiresAt)}</span>
      </div>
    );
  }

  if (isExpired) {
    return (
      <div role="status" className="flex items-start gap-2 px-4 sm:px-5 py-2.5 text-sm text-text-dark bg-damasco/25 border-t border-damasco/60">
        <AlertTriangleIcon className="w-4 h-4 shrink-0 mt-0.5 text-chocolate-dark" />
        <span>A reserva expirou e as peças podem ter sido vendidas. Fale com a gente pelo WhatsApp.</span>
      </div>
    );
  }

  return null;
}
